import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class ReportsAnalyticsTableTour extends BaseTour {
  id = 'reports-analytics-table';

  content = 'Reports & Analytics — Table mode';

  placement: Placement = 'bottom';

  steps = {
    dataTables: () => ({
      content:
        'In Table mode, browse detailed data across three tabs. The Shipment tab shows operational data, the Invoice tab shows statuses and amounts, and the Charges tab shows charge-level breakdowns. Filtering in one tab automatically applies to all tabs --- look for the "Column Filtered" pill.',
      placement: 'top' as Placement,
      scrollOffset: 50,
    }),

    saveExportButtons: () => ({
      content:
        'Save your current report configuration --- either Replace Original to update an existing report, or Save as New with a name and description. Export your current view as CSV or XLSX. Exports respect your active filters, tab, and visible columns.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),
  } as const;
}
